import type { JSX } from 'react';

export type InsertPosition = 'before' | 'after' | 'end' | 'replace';

export enum EmbedPriority {
  High = 3,
  Medium = 2,
  Low = 1,
}

export interface VisitorContext {
  index: number;
  node: JSX.Element;
  nodeTracker: Record<string, number>;
}

export interface ParserRule {
  match: (ctx: VisitorContext) => boolean;
  insertPosition: InsertPosition;
  insertComponent: (ctx: VisitorContext) => JSX.Element;
  priority?: EmbedPriority;
}

export interface ClientParserData {
  args: object;
  func: string;
}
